var error = {
  translation: {
    error: {
      coreNotFound: 'Impossibile recuperare le impostazioni di base',
      domainNotAllowed: "Non puoi registrarti con un'email di questo dominio",
      emailAlreadyInUse: 'Email già in uso',
      insufficientPermissions: 'Permessi insufficienti',
      invalidCurrentPassword: 'Password attuale non valida',
      invalidPermissions: 'Seleziona almeno un permesso',
      invalidUsernameOrPassword: 'Nome utente o password non validi',
      localRegistrationDisabled: "Registrazione locale disabilitata dall'amministratore",
      noInternetConnection: 'Nessuna connessione internet',
      noOidcProfileFound: 'Nessun profilo OIDC trovato',
      policyNotAccepted: 'Accetta Termini di servizio e Informativa sulla privacy',
      registrationDisabled: "Registrazione utenti disabilitata dall'amministratore",
      serverConnectionFailed: 'Connessione al server fallita',
      ssoRegistrationDisabled: "Registrazione SSO disabilitata dall'amministratore",
      tooManyFailedAttempts: 'Troppi tentativi non riusciti - riprova più tardi',
      unknownError: 'Errore sconosciuto, riprova piu tardi',
      usernameAlreadyInUse: 'Username già in uso',
      weakPassword: 'Usa una password più forte',
    },
  },
};

export { error as default };
